import React from 'react';
import { AbsoluteCenter, Box, Link, Center } from '@chakra-ui/react';
import { Text } from '@datavant/uikit';

const email = 'requestmanager@datavant.com';

export const NoAddressesOverlay = () => (
    <AbsoluteCenter
        transition={'all 250ms ease-in-out'}
        axis={'both'}
        backdropFilter={'blur(10px)'}
        width={'100%'}
        height={'100%'}
    >
        <Center height={'100%'}>
            <Text.Status size={'xs'} appearance={'negative'} align={'center'}>
                In order to set up Auto-Fulfillment routing, please reach out to{' '}
                <Text.Interactive appearance={'prominent'} size={'xs'} as={'span'}>
                    <Link href={`mailto:${email}`}>{email}</Link>
                </Text.Interactive>{' '}
                with the address(es) that should be used.
            </Text.Status>
        </Center>
    </AbsoluteCenter>
);
